import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const OrganisationViewModule = new Module({
  id: 'organisation-operation',
  name: 'Organisation',
  path: 'organisation',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/View'))
  ),
  actions: {
    seeliveTracking: {
      id: 'see-live-tracking',
      name: 'change-organisation-live-tracking',
      label: 'See Live Tracking'
    },
    seeRoutePlayback: {
      id: 'see-route-playback',
      name: 'see-organisation-route-playback',
      label: 'See Route Playback'
    }
  }
});

export const OrganisationAddModule = new Module({
  id: 'organisation-add',
  name: 'organisationAdd',
  path: 'organisation/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/Form/add'))
  ),
  actions: {
    add: {
      id: 'add-organisation',
      name: 'add-organisation',
      label: 'Add organisation'
    }
  }
});

export const OrganisationEditSettingsModule = new Module({
  id: 'organisation-edit',
  name: 'organisationEditSettings',
  path: 'organisation/edit-settings',
  pathDef: 'organisation/edit-settings/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/Form/editSettings'))
  ),
  actions: {
    editSettings: {
      id: 'edit-organisation-settings',
      name: 'edit-organisation-settings',
      label: 'Edit Settings'
    }
  }
});

export const OrganisationEditModule = new Module({
  id: 'organisation-edit',
  name: 'OrganisationEdit',
  path: 'organisation/edit',
  pathDef: 'organisation/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/Form/edit'))
  ),
  actions: {
    edit: {
      id: 'edit-organisation-result-table',
      name: 'edit-organisation-result-table',
      label: 'Edit'
    },
    delete: {
      id: 'delete-organisation-result-table',
      name: 'delete-organisation-result-table',
      label: 'Delete'
    },
    sendMail: {
      id: 'send-mail-item',
      name: 'send-mail-item',
      label: 'Send Mail'
    }
  }
});

export const TreeviewModule = new Module({
  id: 'organisation-treeview-module',
  name: 'Organisation-TreeviewModule',
  path: 'organisation/tree-view',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/treeDiagram'))
  ),
  actions: {}
});


const OrganisationModules = [
  OrganisationViewModule,
  OrganisationEditModule,
  OrganisationAddModule,
  OrganisationEditSettingsModule,
  TreeviewModule
];

export default new ModuleBundle('Organisation', OrganisationModules);
